module.exports = "/img/_/_/_/assets/images/creeper/book/legendary//2.jpg?190fc93d63d21eaadaa064960ab229d5";